module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divider",
    style: ({
      width: '100%',
      marginTop: _vm.margin + 'px',
      marginBottom: _vm.margin + 'px',
      display: 'inline-block'
    })
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29b9b546"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/button/btn-dropdown-divider.vue
// module id = 677
// module chunks = 85